import * as React from 'react';

const CrossIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="16" rx="8" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.98911 5.14253C5.75479 4.90822 5.37489 4.90822 5.14058 5.14253C4.90627 5.37685 4.90627 5.75675 5.14058 5.99106L7.12316 7.97364L5.14298 9.95381C4.90867 10.1881 4.90867 10.568 5.14298 10.8023C5.3773 11.0367 5.7572 11.0367 5.99151 10.8023L7.97169 8.82217L9.95186 10.8023C10.1862 11.0367 10.5661 11.0367 10.8004 10.8023C11.0347 10.568 11.0347 10.1881 10.8004 9.95381L8.82021 7.97364L10.8028 5.99106C11.0371 5.75675 11.0371 5.37685 10.8028 5.14253C10.5685 4.90822 10.1886 4.90822 9.95427 5.14253L7.97169 7.12511L5.98911 5.14253Z"
      fill="#0E1323"
      fillOpacity="0.65"
    />
  </svg>
);
export default CrossIcon;
